import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const fillRateTimeseriesResponse = z.array(
  z.object({
    shift_date: z.string(),
    workers_needed_final: z.number().nullable().optional(),
    workers_needed_final_forecast: z.number().nullable().optional(),
    fill_rate: z.number().nullable().optional(),
  })
)

export type FillRateTimeseries = z.infer<typeof fillRateTimeseriesResponse>

export async function getFillRateTimeseries(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/fill_rate_timeseries', data, { signal })
    .then((response) => response.data)
    .then(fillRateTimeseriesResponse.parse)
}

export async function getFillRateTimeseriesCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/fill_rate_timeseries/csv', data, {
      signal,
    })
    .then((response) => response.data)
}
